module.exports = __webpack_public_path__ + "vue/img/facility_inside_2.7fa71e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/intro/facility_inside_2.png
// module id = m7Nc
// module chunks = 1